/**
 * DEV-3392: AGサンクスから引き継いだパターン（Cookie ab_pattern_3392）で、PF転換フォームの計測ラベルに接尾辞を付ける。
 * GTMは data-click-label / data-view-label を読むため、ラベル文字列を変えればGA4にもそのまま届く。
 *
 * PFでは振り分けないため、ab_value を使う AB_TEST_CONFIGS には載せない
 * （載せると、サンクスを経由していない人まで乱数でB〜Dとして計測される）。
 * Cookieが無い・A・許可リスト外のときはラベルをそのまま返すので、既存のABテストのラベルは変わらない。
 * テストを終えるときは、このファイルと useAbTestGtm の呼び出しを消す。
 */
const ISSUE_NUMBER = '3392'
const PATH_REGEX = /^\/job_seekers\/[^/]+\/edit/
// サーバーでも許可リストを通しているが、DOMの値なので念のためここでも確認する。Aは接尾辞なし
const SUFFIX_PATTERNS = ['B', 'C', 'D']

// Cookieはhttponlyで読めないため、サーバーが許可リストを通して出した値を読む（edit_react.html.erb）
const getHandoffPattern = (): string | undefined => {
    if (typeof document === 'undefined') return undefined
    return document.getElementById(`ab-handoff-${ISSUE_NUMBER}`)?.dataset
        .pattern
}

export const appendHandoffSuffix = (
    label: string,
    currentPath: string
): string => {
    if (!PATH_REGEX.test(currentPath)) return label

    const pattern = getHandoffPattern()
    if (!pattern || !SUFFIX_PATTERNS.includes(pattern)) return label

    return `${label}_${ISSUE_NUMBER}_${pattern}`
}
